import { Button, Typography } from "@material-ui/core";
import { ServiceFormQuestionUIModel } from "../../../graphql/models";
import { ServiceSurveyQuestion } from "./service_survey_question";

export interface ServiceSurveyProps {
  items: ServiceFormQuestionUIModel[] | undefined;
  onUpdate: (items: ServiceFormQuestionUIModel[]) => void;
}

export function ServiceSurvey(props: ServiceSurveyProps) {
  const { items } = props;
  // handlers
  const onUpdateHandler = (item: ServiceFormQuestionUIModel, index: number) => {
    let result;
    if (items && items.length > 0) {
      result = [...items];
      result[index] = { ...item };
    } else {
      result = [{ ...item }];
    }
    props.onUpdate(result);
  };
  const newItemHandler = () => {
    const newItem: ServiceFormQuestionUIModel = {
      i18n: {},
      required: false,
      deleted: false,
      sortIndex: ((items?.length || 0) + 1) * 10,
    };
    let result;
    if (items && items.length > 0) {
      result = [...items, newItem];
    } else {
      result = [newItem];
    }
    props.onUpdate(result);
  };
  return (
    <>
      <Typography variant="h4">Domande in app</Typography>
      {items &&
        items?.map((item, index) => (
          <ServiceSurveyQuestion
            item={item}
            onUpdate={(item) => onUpdateHandler(item, index)}
            key={`question${index}`}
          ></ServiceSurveyQuestion>
        ))}
      {(items?.length || 0) === 0 && <p>Nessuna domanda da mostrare in app</p>}
      <Button variant="outlined" onClick={newItemHandler}>
        Aggiungi
      </Button>
    </>
  );
}
